import type { FaireProductEntity } from "../../entity_types/product";

export const p_ghhxv58z7h: FaireProductEntity = {
  token: "p_ghhxv58z7h",
  type: "product",
  name: "Miaoberry Woodland 100% Organic Cotton Muslin Milestone Blanket",
  brandToken: "b_6jbtamncqg",
  brandName: "Miaoberry",
  imageUrl:
    "https://cdn.faire.com/fastly/8a63dcf467b528a8983040198e4b5f52bc4bfb0ed2cd5620ec87894cf65f95ce.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9418e4e551cd9ff4ad2fdf088f9c369e5bbc7e2de23be9fa2d1c75dcf7ee31f4.jpeg",
    "https://cdn.faire.com/fastly/297afb56b76ee53b1bb871b3d3533e54ccc95c54f49d68a28c8b6cd3a46414fb.jpeg",
    "https://cdn.faire.com/fastly/8bcc8136c82dd029a179542e4f66717630a649561f62824eae6340385851cd8a.jpeg",
    "https://cdn.faire.com/fastly/e574fdddf6802faef574fe25b5478ddc90f95e775007d91636868212ead3f9ee.jpeg",
    "https://cdn.faire.com/fastly/17261459e584faeb4a673d8b9923081bc8ce8ebd58da505cab9f39ef999da388.jpeg",
  ],
  priceDollars: 14.98,
  description:
    "\n * 💚 BUT FIRST, SAFE|ORGANIC-- Protect Your Baby and Our Mother Earth. Say No to All Harmful Chemicals and Processes. Designed to Sooth Even the Most Sensitive Skin, Miaoberry 100% Certified Organic Cotton Muslin Photo Blanket Is the Softest, Toxic-Free, Safe Blanket for Your Precious Baby. The Open Weave of Muslin Makes It Thermal Regulating and Naturally Stretchy. It’s also Hypoallergenic and Gentle. \n * 💚 AND EVERYBODY LOVES WOODLAND THEME–Every Miaoberry Picture Blanket Is Uniquely Designed, Hand Illustrated and Printed With Baby-Safe, Eco-Friendly Ink. This Boho Woodland Age Blanket with Little Deer (Fawn), Hedgehog, Bunny Rabbit, Squirrel ,Snail, Mushrooms and Green Leaves, It's So Nature!",
  tags: [],
  msrpDollars: 29.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:51.021Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
